module.exports = __webpack_public_path__ + "static/media/activityTypePill-story.e9695aa5.svg";